// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ComparisonTable-eh-comparison-TOomp {
  width: 100%;
  background: #ffffff;
  padding: 40px 24px 64px;
}

.ComparisonTable-eh-comparison__container-JC5HX {
  max-width: 1345px;
  margin: 0 auto;
}

.ComparisonTable-eh-comparison__heading-fm_gF {
  font-family: 'Roboto Flex', var(--font-family-base), -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 38px;
  font-weight: 700;
  color: #003453;
  text-align: center;
  margin: 0 0 36px 0;
}

.ComparisonTable-eh-comparison__card-lPtsQ {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  background: rgba(171, 228, 255, 0.4);
  border: 1px solid #009CFF;
  border-radius: 19px;
  overflow: hidden;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.ComparisonTable-eh-table-xNKxy {
  width: 100%;
  min-width: 900px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
}

.ComparisonTable-eh-table__header-row-lSUZO {
  display: grid;
  grid-template-columns: 1.8fr 1.05fr 1.35fr 1.05fr;
  -webkit-box-align: stretch;
      -ms-flex-align: stretch;
          align-items: stretch;
  min-height: 110px;
}

.ComparisonTable-eh-table__row-AXYOx {
  display: grid;
  grid-template-columns: 1.8fr 1.05fr 1.35fr 1.05fr;
  -webkit-box-align: stretch;
      -ms-flex-align: stretch;
          align-items: stretch;
  min-height: 72px;
}

.ComparisonTable-eh-table__cell-vs_BH {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  font-family: 'Roboto Flex', var(--font-family-base), -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

/* Feature Labels */

.ComparisonTable-eh-table__cell--label-aAK6t {
  font-weight: 700;
  font-size: 24px;
  line-height: 1.25;
  color: #003453;
  padding: 14px 20px 14px 40px;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
  text-align: left;
}

.ComparisonTable-eh-table__cell--label-head-e9aXu {
  padding-left: 40px;
}

/* Eslipin column */

.ComparisonTable-eh-table__cell--eslipin-jYbrF {
  background: rgba(255, 255, 255, 0.4);
  border-left: 1px solid #FFFFFF;
  border-right: 1px solid #FFFFFF;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  text-align: center;
  padding: 10px 16px;
}

/* Otras plataformas internacionales column */

.ComparisonTable-eh-table__cell--internacionales-oYMyu {
  border-right: 1px solid #FFFFFF;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  text-align: center;
  padding: 10px 16px;
}

/* Marketplace column */

.ComparisonTable-eh-table__cell--marketplace-NTRCW {
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  text-align: center;
  padding: 10px 16px;
}

/* Column Headers */

.ComparisonTable-eh-table__cell--header-uSnRQ {
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
  color: #003453;
  text-align: center;
}

.ComparisonTable-eh-table__cell--brand-uO6u3 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.ComparisonTable-eh-brand-header-Hm0GU {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  width: 100%;
}

.ComparisonTable-eh-brand-logo-b9NTS {
  height: 58px;
  max-width: 185px;
  -o-object-fit: contain;
     object-fit: contain;
}

/* Data Cells */

.ComparisonTable-eh-table__cell--data-E0L5E {
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  text-align: center;
}

/* Values */

.ComparisonTable-eh-val-_6R44 {
  font-size: 36px;
  font-weight: 700;
  line-height: 1;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  text-align: center;
}

.ComparisonTable-eh-val--positive-_miOv {
  color: #00C987;
}

.ComparisonTable-eh-val--negative-PYDAI {
  color: #BC3A2B;
}

/* Icons */

.ComparisonTable-eh-icon-check-p4hER {
  display: block;
}

.ComparisonTable-eh-icon-cross-iqIK3 {
  display: block;
}

@media (max-width: 1100px) {
  .ComparisonTable-eh-table__cell--label-aAK6t {
    font-size: 20px;
    padding-left: 24px;
  }
  .ComparisonTable-eh-table__cell--header-uSnRQ {
    font-size: 20px;
  }
  .ComparisonTable-eh-val-_6R44 {
    font-size: 30px;
  }
  .ComparisonTable-eh-brand-logo-b9NTS {
    height: 48px;
  }
}

@media (max-width: 768px) {
  .ComparisonTable-eh-comparison-TOomp {
    padding: 32px 16px 48px;
  }
  .ComparisonTable-eh-comparison__heading-fm_gF {
    font-size: 26px;
    margin-bottom: 24px;
  }
  .ComparisonTable-eh-table-xNKxy {
    min-width: 780px;
  }
  .ComparisonTable-eh-table__cell--label-aAK6t {
    font-size: 18px;
    padding-left: 20px;
  }
  .ComparisonTable-eh-table__cell--header-uSnRQ {
    font-size: 18px;
  }
  .ComparisonTable-eh-val-_6R44 {
    font-size: 26px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/WhyhostView/ComparisonTable.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sHAAsH;EACtH,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,8BAAsB;UAAtB,sBAAsB;EACtB,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,iDAAiD;EACjD,0BAAoB;MAApB,uBAAoB;UAApB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iDAAiD;EACjD,0BAAoB;MAApB,uBAAoB;UAApB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,8BAAsB;UAAtB,sBAAsB;EACtB,sHAAsH;AACxH;;AAEA,mBAAmB;;AACnB;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,4BAA4B;EAC5B,uBAA2B;MAA3B,oBAA2B;UAA3B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,mBAAmB;;AACnB;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,+BAA+B;EAC/B,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,6CAA6C;;AAC7C;EACE,+BAA+B;EAC/B,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,uBAAuB;;AACvB;EACE,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,mBAAmB;;AACnB;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,sBAAmB;KAAnB,mBAAmB;AACrB;;AAEA,eAAe;;AACf;EACE,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,WAAW;;AACX;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,UAAU;;AACV;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".eh-comparison {\n  width: 100%;\n  background: #ffffff;\n  padding: 40px 24px 64px;\n}\n\n.eh-comparison__container {\n  max-width: 1345px;\n  margin: 0 auto;\n}\n\n.eh-comparison__heading {\n  font-family: 'Roboto Flex', var(--font-family-base), -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  font-size: 38px;\n  font-weight: 700;\n  color: #003453;\n  text-align: center;\n  margin: 0 0 36px 0;\n}\n\n.eh-comparison__card {\n  box-sizing: border-box;\n  background: rgba(171, 228, 255, 0.4);\n  border: 1px solid #009CFF;\n  border-radius: 19px;\n  overflow: hidden;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.eh-table {\n  width: 100%;\n  min-width: 900px;\n  display: flex;\n  flex-direction: column;\n}\n\n.eh-table__header-row {\n  display: grid;\n  grid-template-columns: 1.8fr 1.05fr 1.35fr 1.05fr;\n  align-items: stretch;\n  min-height: 110px;\n}\n\n.eh-table__row {\n  display: grid;\n  grid-template-columns: 1.8fr 1.05fr 1.35fr 1.05fr;\n  align-items: stretch;\n  min-height: 72px;\n}\n\n.eh-table__cell {\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  font-family: 'Roboto Flex', var(--font-family-base), -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n/* Feature Labels */\n.eh-table__cell--label {\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 1.25;\n  color: #003453;\n  padding: 14px 20px 14px 40px;\n  justify-content: flex-start;\n  text-align: left;\n}\n\n.eh-table__cell--label-head {\n  padding-left: 40px;\n}\n\n/* Eslipin column */\n.eh-table__cell--eslipin {\n  background: rgba(255, 255, 255, 0.4);\n  border-left: 1px solid #FFFFFF;\n  border-right: 1px solid #FFFFFF;\n  justify-content: center;\n  text-align: center;\n  padding: 10px 16px;\n}\n\n/* Otras plataformas internacionales column */\n.eh-table__cell--internacionales {\n  border-right: 1px solid #FFFFFF;\n  justify-content: center;\n  text-align: center;\n  padding: 10px 16px;\n}\n\n/* Marketplace column */\n.eh-table__cell--marketplace {\n  justify-content: center;\n  text-align: center;\n  padding: 10px 16px;\n}\n\n/* Column Headers */\n.eh-table__cell--header {\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.2;\n  color: #003453;\n  text-align: center;\n}\n\n.eh-table__cell--brand {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.eh-brand-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.eh-brand-logo {\n  height: 58px;\n  max-width: 185px;\n  object-fit: contain;\n}\n\n/* Data Cells */\n.eh-table__cell--data {\n  justify-content: center;\n  text-align: center;\n}\n\n/* Values */\n.eh-val {\n  font-size: 36px;\n  font-weight: 700;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.eh-val--positive {\n  color: #00C987;\n}\n\n.eh-val--negative {\n  color: #BC3A2B;\n}\n\n/* Icons */\n.eh-icon-check {\n  display: block;\n}\n\n.eh-icon-cross {\n  display: block;\n}\n\n@media (max-width: 1100px) {\n  .eh-table__cell--label {\n    font-size: 20px;\n    padding-left: 24px;\n  }\n  .eh-table__cell--header {\n    font-size: 20px;\n  }\n  .eh-val {\n    font-size: 30px;\n  }\n  .eh-brand-logo {\n    height: 48px;\n  }\n}\n\n@media (max-width: 768px) {\n  .eh-comparison {\n    padding: 32px 16px 48px;\n  }\n  .eh-comparison__heading {\n    font-size: 26px;\n    margin-bottom: 24px;\n  }\n  .eh-table {\n    min-width: 780px;\n  }\n  .eh-table__cell--label {\n    font-size: 18px;\n    padding-left: 20px;\n  }\n  .eh-table__cell--header {\n    font-size: 18px;\n  }\n  .eh-val {\n    font-size: 26px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"eh-comparison": `ComparisonTable-eh-comparison-TOomp`,
	"eh-comparison__container": `ComparisonTable-eh-comparison__container-JC5HX`,
	"eh-comparison__heading": `ComparisonTable-eh-comparison__heading-fm_gF`,
	"eh-comparison__card": `ComparisonTable-eh-comparison__card-lPtsQ`,
	"eh-table": `ComparisonTable-eh-table-xNKxy`,
	"eh-table__header-row": `ComparisonTable-eh-table__header-row-lSUZO`,
	"eh-table__row": `ComparisonTable-eh-table__row-AXYOx`,
	"eh-table__cell": `ComparisonTable-eh-table__cell-vs_BH`,
	"eh-table__cell--label": `ComparisonTable-eh-table__cell--label-aAK6t`,
	"eh-table__cell--label-head": `ComparisonTable-eh-table__cell--label-head-e9aXu`,
	"eh-table__cell--eslipin": `ComparisonTable-eh-table__cell--eslipin-jYbrF`,
	"eh-table__cell--internacionales": `ComparisonTable-eh-table__cell--internacionales-oYMyu`,
	"eh-table__cell--marketplace": `ComparisonTable-eh-table__cell--marketplace-NTRCW`,
	"eh-table__cell--header": `ComparisonTable-eh-table__cell--header-uSnRQ`,
	"eh-table__cell--brand": `ComparisonTable-eh-table__cell--brand-uO6u3`,
	"eh-brand-header": `ComparisonTable-eh-brand-header-Hm0GU`,
	"eh-brand-logo": `ComparisonTable-eh-brand-logo-b9NTS`,
	"eh-table__cell--data": `ComparisonTable-eh-table__cell--data-E0L5E`,
	"eh-val": `ComparisonTable-eh-val-_6R44`,
	"eh-val--positive": `ComparisonTable-eh-val--positive-_miOv`,
	"eh-val--negative": `ComparisonTable-eh-val--negative-PYDAI`,
	"eh-icon-check": `ComparisonTable-eh-icon-check-p4hER`,
	"eh-icon-cross": `ComparisonTable-eh-icon-cross-iqIK3`
};
module.exports = ___CSS_LOADER_EXPORT___;
